module.exports = require("react-placeholder/lib/placeholders");